import { render, staticRenderFns } from "./PlacesOfService.vue?vue&type=template&id=52d3a231&"
import script from "./PlacesOfService.vue?vue&type=script&lang=js&"
export * from "./PlacesOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports